<template>
  <div class="h-24 bg-white border-t border-grey-light flex flex-col">
    <!-- Barra de estado (status bar) -->
    <div class="h-6 bg-grey-lightest border-b border-grey-light flex items-center justify-between px-4">
      <div class="flex items-center">
        <span class="text-xs text-grey-dark">{{ $t('working_on_the_view') }}:&nbsp;</span>
        <span class="text-gray-700 lowercase font-semibold text-xs">{{ name_vista }}
        </span>
      </div>
      <div class="flex items-center">
        <span class="text-xs text-grey-dark">{{ $t('selected_elements') }}:&nbsp;</span>
        <span class="text-gray-700 font-semibold text-xs">{{ selectedCount || 0 }}</span>
      </div>
    </div>

    <!-- Sección de menús -->
    <div class="epc-toolbar flex-1 flex items-center justify-center space-x-6 px-4">
      <div id="settingsTools" class="epc-control-group">

        <div v-if="actions.showButtonCompletion && !viewOnly"
          id="toolbar-completedStatusesTools"
          class="epc-button inactive"
          :class="{ 'active' : showLayerCompleted }"
          @click="(e) => { showLayerCompleted = !showLayerCompleted; $emit('epc-click-show-completion', showLayerCompleted) }">
            <b-tooltip :label="$t('show_completed_structures')"
            position="is-left">
            <b-icon pack="fas" icon="check-square"></b-icon>
          </b-tooltip>
        </div>

        <!-- <div id="toolbar-layersTools" class="epc-button inactive" :class="{ 'active' : showLayerPanel }" @click="(e) => showLayerPanel = !showLayerPanel">
          <b-icon pack="fas" icon="layer-group"></b-icon>
        </div> -->

        <!-- <div v-for="(lyr, index) of pictogram.layers" :key="lyr.id"
          class="epc-button inactive"
          :id="'toolbar-' + lyr.code.toLowerCase() + 'Tools'"
          :class="{ 'active' : displayPictogramLayer === lyr.code }"
          @click="_OnClickDisplayLayerPictogram(lyr.code)">
            <b-icon pack="fas" :icon="_GetIcon(lyr)"></b-icon>
        </div> -->
      </div>

      <div id="settingsTools" class="epc-control-group">
        <div id="toolbar-panTool" class="epc-button inactive"
          :class="{ 'active' : isDraggable }" @click="() => $emit('epc-click-pan')">
          <b-icon pack="fas" icon="hand-paper"></b-icon>
        </div>
        <div id="toolbar-fitTools" class="epc-button inactive" @click="() => $emit('epc-click-fit')">
          <b-icon pack="fas" icon="arrows-to-circle"></b-icon>
        </div>
        <div id="toolbar-zoomInTools" class="epc-button inactive" @click="() => $emit('epc-click-zoom-in', true)">
          <b-icon pack="fas" icon="search-plus"></b-icon>
        </div>
        <div id="toolbar-zoomOutTools" class="epc-button inactive" @click="() => $emit('epc-click-zoom-out', false)">
          <b-icon pack="fas" icon="search-minus"></b-icon>
        </div>

        <!-- Dropdown de herramientas de selección -->
        <SplitActionDropdown v-if="!viewOnly"
          :options="resolvedSelectionOptions"
          :selected-option="selectedOption"
          :is-active="isSelecting"
          button-id="toolbar-selectingTools"
          @option-selected="handleSelectionOption"
        />

        <div v-if="!viewOnly" id="toolbar-selectingTools" class="epc-button inactive"
          @click="() => $emit('epc-click-unselect')">
          <b-icon pack="fas" icon="object-ungroup"></b-icon>
        </div>

        <div id="toolbar-fullscreenTools" class="epc-button inactive" @click="() => $emit('epc-click-fullscreen')">
          <b-icon pack="fas" icon="expand"></b-icon>
        </div>
      </div>

      <!-- Grupo de geolocalización -->
      <div id="geoTools" class="epc-control-group">
        <div v-if="geoReferenceConfigured"
          id="toolbar-toggleMapTools"
          class="epc-button inactive"
          :class="{ 'active' : showGoogleMaps }"
          @click="() => $emit('epc-click-toggle-map')">
          <b-tooltip :label="showGoogleMaps ? $t('hide_map') : $t('show_map')"
            position="is-top">
            <b-icon pack="fas" :icon="showGoogleMaps ? 'map-marked-alt' : 'map'"></b-icon>
          </b-tooltip>
        </div>
      </div>

      <div id="settingsTools" class="epc-control-group">
        <!-- Dropdown Registrar Progreso -->
        <SplitActionDropdown
          v-if="actions.registerProgress && !viewOnly"
          :options="progressOptions"
          :selected-option="selectedProgressOption"
          :default-option="progressOptions[0]"
          button-id="toolbar-registerProgressTools"
          main-icon="traffic-light"
          @option-selected="handleProgressOption"
        />

        <!-- Dropdown Registrar Incidencia -->
        <SplitActionDropdown
          v-if="actions.registerIncident && !viewOnly"
          :options="incidentOptions"
          :selected-option="selectedIncidentOption"
          :default-option="incidentOptions[0]"
          button-id="toolbar-registerIncidentTools"
          main-icon="exclamation-triangle"
          @option-selected="handleIncidentOption"
        />

        <div v-if="actions.assignValidationFlow && !viewOnly"
          id="toolbar-assignValidationFlowTools"
          class="epc-button inactive"
          @click="() => $emit('epc-click-register', 'assign-validation-flow')">
          <b-tooltip :label="$t('assign_validation_flow')"
            position="is-left">
            <b-icon pack="fas" icon="project-diagram"></b-icon>
          </b-tooltip>
        </div>
      </div>

      <div v-if="actions.save && !viewOnly"
        id="settingsTools"
        class="epc-control-group">
        <div id="toolbar-saveTools" class="epc-button inactive" @click="() => $emit('epc-click-save')">
          <b-icon pack="fas" icon="save"></b-icon>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SplitActionDropdown from '@pictograms/shared/components/buttons/SplitActionDropdown.vue';


  export default {
    name: "ViewerFooter",

    components: {
      SplitActionDropdown
    },

    props: {
      name_vista: {
        type: String,
        default: '',
      },
      actions: {
        type: Object,
        required: true,
      },
      displayPictogramLayer: {
        type: String,
        default: '',
      },
      isDraggable: {
        type: Boolean,
        default: false,
      },
      isSelecting: {
        type: Boolean,
        default: false,
      },
      selectedCount: {
        type: Number,
        default: 0,
      },
      viewOnly: {
        type: Boolean,
        default: false,
      },
      geoReferenceConfigured: {
        type: Boolean,
        default: false,
      },
      showGoogleMaps: {
        type: Boolean,
        default: false,
      },
      selectionOptions: {
        type: Array,
        default: () => [],
      },
      defaultSelectionOption: {
        type: String,
        default: 'select',
      },
    },

    data() {
      return {
        showLayerCompleted: false,
        selectedOption: null,
        selectedProgressOption: null,
        selectedIncidentOption: null,
      }
    },

    computed: {
      ...mapGetters({
        company: 'app/company',
      }),

      // Aliases de compañías que tienen acceso a opciones avanzadas (revert y clear)
      companiesWithAdvancedOptions() {
        return ['solaring', 'prg'];
      },

      // Verifica si la compañía actual tiene acceso a opciones avanzadas
      hasAdvancedOptions() {
        return this.company && this.companiesWithAdvancedOptions.includes(this.company.alias);
      },

      defaultSelectionOptions() {
        return [
          { value: 'select', label: this.$t('select'), icon: 'object-group' },
          { value: 'unselect', label: this.$t('unselect'), icon: 'object-ungroup' },
          // { value: 'select-by-status', label: this.$t('select_by_status'), icon: 'traffic-light' },
          // { value: 'select-by-incident-status', label: this.$t('select_by_incident_status'), icon: 'exclamation-triangle' },
          // { value: 'select-without-status', label: this.$t('select_without_status'), icon: 'ban' },
          // { value: 'select-without-incident', label: this.$t('select_without_incident'), icon: 'check-circle' },
        ];
      },

      resolvedSelectionOptions() {
        if (this.selectionOptions && this.selectionOptions.length > 0) {
          return this.selectionOptions.map(opt => ({
            ...opt,
            label: opt.labelKey ? this.$t(opt.labelKey) : opt.label,
          }));
        }
        return this.defaultSelectionOptions;
      },

      // Opciones adicionales que se agregan para compañías con acceso avanzado
      advancedOptions() {
        return [
          { value: 'revert', label: this.$t('back_to_previous_status'), icon: 'undo' },
          { value: 'clear', label: this.$t('clear_status'), icon: 'ban' }
        ];
      },

      // Opciones de progreso: por defecto solo 'register', agregar 'revert' y 'clear' para compañías autorizadas
      progressOptions() {
        const baseOptions = [
          { value: 'register', label: this.$t('register_progress'), icon: 'traffic-light' },
        ];

        if (this.hasAdvancedOptions) {
          baseOptions.push(...this.advancedOptions);
        }

        return baseOptions;
      },

      // Opciones de incidencia: por defecto solo 'register', agregar 'revert' y 'clear' para compañías autorizadas
      incidentOptions() {
        const baseOptions = [
          { value: 'register', label: this.$t('register_incident'), icon: 'exclamation-triangle' },
        ];

        if (this.hasAdvancedOptions) {
          baseOptions.push(
            { value: 'revert', label: this.$t('back_to_previous_status'), icon: 'undo' },
            { value: 'clear', label: this.$t('clear_incident'), icon: 'ban' }
          );
        }

        return baseOptions;
      },
    },

    created() {
      this.initializeSelectedOption();
      this.selectedProgressOption = this.progressOptions[0];
      this.selectedIncidentOption = this.incidentOptions[0];
    },

    watch: {
      selectionOptions: {
        immediate: true,
        handler() {
          this.initializeSelectedOption();
        }
      },
      defaultSelectionOption() {
        this.initializeSelectedOption();
      },
      progressOptions(options) {
        if (!this.selectedProgressOption && options.length) {
          this.selectedProgressOption = options[0];
        }
      },
      incidentOptions(options) {
        if (!this.selectedIncidentOption && options.length) {
          this.selectedIncidentOption = options[0];
        }
      },
    },

    methods: {
      initializeSelectedOption() {
        const options = this.resolvedSelectionOptions;
        const defaultOption = options.find(opt => opt.value === this.defaultSelectionOption) || options[0];

        if (defaultOption) {
          this.selectedOption = defaultOption;
        }
      },

      handleSelectionOption(option) {
        this.selectedOption = option;
        // Emitir evento según la opción seleccionada
        if (option.value === 'select') {
          this.$emit('epc-click-selecting');
        } else if (option.value === 'unselect') {
          this.$emit('epc-click-unselect');
        } else {
          this.$emit('epc-click-selection-option', option);
        }
      },

      handleProgressOption(option) {
        this.selectedProgressOption = option;
        if (option.value === 'register') {
          this.$emit('epc-click-register', 'progress');
        } else if (option.value === 'revert') {
          this.$emit('epc-click-register', { type: 'progress', action: 'revert' });
        } else if (option.value === 'clear') {
          this.$emit('epc-click-register', { type: 'progress', action: 'clear' });
        }
      },

      handleIncidentOption(option) {
        this.selectedIncidentOption = option;
        if (option.value === 'register') {
          this.$emit('epc-click-register', 'incident');
        } else if (option.value === 'revert') {
          this.$emit('epc-click-register', { type: 'incident', action: 'revert' });
        } else if (option.value === 'clear') {
          this.$emit('epc-click-register', { type: 'incident', action: 'clear' });
        }
      },
    },
  }

</script>

<style scoped>

.epc-toolbar {
  pointer-events: none;
  text-align: center;
  width: calc(100% - 20px);
  z-index: 5;
  overflow: visible;
}
.epc-toolbar .epc-control-group {
  background-color: rgba(34,34,34,.94);
  box-shadow: 1px 3px 10px 0 rgba(0,0,0,.5);
  color: #f4f4f4;

  border-radius: 5px;
  display: inline-block;
  margin: 0 5px;
  pointer-events: all;
}

.epc-toolbar .epc-control-group .layerTools{
  border-radius: 3px;
  box-shadow: inset 0 2px 2px 0 #000;
  color: #00bfff;
  outline: none;
}

.epc-button{
  border: 1px solid rgba(34,34,34,0);
  border-radius: 4px;
  cursor: pointer;
  float: left;
  margin: 4px;
  /* Tamaño fijo 30×30 para que TODOS los botones (sueltos y el principal del
     SplitActionDropdown) tengan el mismo tamaño; icono centrado. */
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.epc-button:hover,
.epc-button.active {
  border: 1px solid #00bfff;
  color: #00bfff;
}

.epc-button.active,
.epc-button:focus {
  border-radius: 3px;
  box-shadow: inset 0 2px 2px 0 #000;
  color: #00bfff;
  outline: none;
}

/* ─────────────────────────────────────────────────────────────────────────
   Tema OSCURO LOCAL del SplitActionDropdown dentro de este footer.
   El componente compartido (shared/.../SplitActionDropdown.vue) quedó CLARO
   para el toolbar del studio; aquí lo forzamos a oscuro/cian con :deep para que
   combine con las pills negras del viewer-pixi, SIN tocar el componente. Temporal
   hasta la unificación del chrome.
   ───────────────────────────────────────────────────────────────────────── */
.epc-toolbar :deep(.epc-dropdown-container) {
  margin: 4px;
  vertical-align: middle;
}

.epc-toolbar :deep(.epc-dropdown-button-group) {
  background: transparent;
  border: 1px solid transparent;
}

.epc-toolbar :deep(.epc-dropdown-main-button),
.epc-toolbar :deep(.epc-dropdown-arrow-button) {
  color: #f4f4f4;
  background: transparent;
}

.epc-toolbar :deep(.epc-dropdown-main-button) {
  border-right-color: rgba(255, 255, 255, 0.12);
}

.epc-toolbar :deep(.epc-dropdown-button-group.active),
.epc-toolbar :deep(.epc-dropdown-button-group.arrow-hover) {
  border-color: #00bfff;
}

.epc-toolbar :deep(.epc-dropdown-button-group.active .epc-button),
.epc-toolbar :deep(.epc-dropdown-button-group.arrow-hover .epc-button) {
  color: #00bfff;
  background: transparent;
}

.epc-toolbar :deep(.epc-dropdown-button-group .epc-button:hover) {
  color: #00bfff;
  background: rgba(255, 255, 255, 0.06);
}

/* Menú desplegable en oscuro para que no abra en blanco sobre el footer negro. */
.epc-toolbar :deep(.epc-dropdown-menu) {
  background: rgba(34, 34, 34, 0.97);
  border-color: rgba(255, 255, 255, 0.12);
}

.epc-toolbar :deep(.epc-dropdown-item) {
  color: #f4f4f4;
}

.epc-toolbar :deep(.epc-dropdown-item:hover),
.epc-toolbar :deep(.epc-dropdown-item.active) {
  background: rgba(255, 255, 255, 0.08);
  color: #00bfff;
}

</style>
